/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2019 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/
import BaseApi from '../api/BaseApi';
import type {PulseApi as Contract, PulseButtonConfig, PulseNotification, PulseResponse} from '@adobe/exc-app/pulse';
import {Events} from '@exc/shared';

export class PulseApi extends BaseApi implements Contract {
  protected keyPrefix = 'pulse';
  protected apiEvents = ['pulse'];
  protected defaultType = 'pulse';
  protected event = Events.EXC_PULSE;
  public send = this.handler<PulseNotification[], PulseResponse>('POST');

  public setCount(count: number): void {
    this.configManager.set({'pulse/count': count});
  }

  public setButton(buttonConfig: PulseButtonConfig): void {
    buttonConfig ?
      this.configManager.update('pulse/button', buttonConfig, Events.PULSE_BUTTON) :
      this.configManager.clear('pulse/button', Events.PULSE_BUTTON);
  }
}
